import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box } from "@mui/material";
import "moment/locale/hu";
import { MyHrMonthSelector, MyHrPayrollCollapse } from "my-hr/components";
import {
  useMyHrContractsByEmployeeByPeriod,
  useMyHrPaycard,
} from "my-hr/hooks";
import { useOcCurrentUserState } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyHrPaycardProps {
  contract: string;
  year: string;
  month: string;
  onClose?: () => void;
  previousPaycard?: () => void;
  nextPaycard?: () => void;
}

export const MyHrPaycard: React.FC<MyHrPaycardProps> = ({
  contract,
  year,
  month,
  onClose,
  previousPaycard,
  nextPaycard,
}) => {
  const { i18n } = useTranslation();
  const isMobile = useOcIsMobile();

  let { employeeCode } = useOcCurrentUserState();

  let startDate = moment(`${year}-${month}`)
    .startOf("month")
    .format("YYYYMMDD");

  let endDate = moment(`${year}-${month}`).endOf("month").format("YYYYMMDD");

  const { data: contractsData } = useMyHrContractsByEmployeeByPeriod({
    employee: employeeCode,
    startDate,
    endDate,
  });

  const { error } = useMyHrPaycard({
    contract,
    year,
    month,
  });

  let showStartOfContract =
    contractsData?.employmentType?.code === "2" ? false : true;

  let monthName = moment(`${year}-${month}`)
    .locale(i18n.language)
    .format("MMMM");

  return (
    <Box>
      <MyHrMonthSelector
        year={year}
        month={monthName}
        onClose={onClose ?? (() => {})}
        previousonClick={previousPaycard ?? (() => {})}
        nextOnClick={nextPaycard ?? (() => {})}
        backChevron={true}
        isMobile={isMobile}
      />
      {error ? (
        <Box padding="16px">
          <span>
            JDolBerAPIGateway error (contractCode: {contract}, year: {year},
            month: {month})
          </span>
        </Box>
      ) : (
        <>
          <Box height="16px" />
          {contractsData?.map((item: any, index: number) => (
            <Box key={`${item}-${index}`}>
              <MyHrPayrollCollapse
                index={index}
                label={item?.jobClass?.name}
                ContractID={item?.code}
                showStartOfContract={showStartOfContract}
                company={item?.company?.name}
                workingPlace={item?.workingPlace?.name}
                orgUnit={item?.orgUnit?.name}
                payOffice={item?.payOffice?.name}
                startOfContract={item?.startOfContract}
                employmentType={item?.employmentType?.name}
                month={month}
                year={year}
                contract={item?.code}
              />
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};

export default MyHrPaycard;
